export default {
    create_diagnostic_device_title: "Create Diagnostic",
    create_diagnostic_device_create: "Create",
    create_diagnostic_device_transaction_request_message:"The diagnostic request has been received. Click here to see the diagnostic status.",

    create_diagnostic_device_the_device_has_not_been_found: "The device has not been found",
    create_diagnostic_device_the_device_has_already_been_added: "The device has already been added",
    create_diagnostic_device_the_devices_has_already_been_added: "Some devices already added to the list",
    create_diagnostic_device_the_unit_type_of_the_device_must_bet_the_same: "The unit type of the devices must be the same",
    create_diagnostic_device_the_manufacturer_of_the_devices_must_be_the_same: "The manufacturer of the devices must be the same",
    create_diagnostic_device_imei_or_serial: "IMEI or Serial",
    create_diagnostic_device_imei: "IMEI",
    create_diagnostic_device_serial: "Serial",
    create_diagnostic_device_model: "Model",
    create_diagnostic_device_commands_sent: "Commands Sent",
    create_diagnostic_device_status: "Status",
    create_diagnostic_device_complete: "Complete",
    create_diagnostic_device_send_more_commands: "Send More Commands",
    create_diagnostic_device_mass_sms_title: "Mass SMS",
    
    create_diagnostic_device_command_to_send: "Command to send",
    create_diagnostic_device_canned_commands: "Canned Commands",
    create_diagnostic_device_phone_numbers: "Phone #'s",
    create_diagnostic_device_unit_type: "Unit Type",
    create_diagnostic_device_error_phone_length: "Phone number length is not between 10 and 15 digits",
    create_diagnostic_device_error_phone_not_number: "Phone number is not a valid number",
    create_diagnostic_device_send_type: "Send Type",
    create_diagnostic_device_unvalid_phone_numbers: "There are not valid phone numbers to send the command",
    create_diagnostic_device_errors: "Errors",
    create_diagnostic_device_sent: "Command sent to",
    create_diagnostic_device_error_duplicate_phone: "Duplicate phone number",
}